import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { UploaderService } from './uploader.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MoneytorEventsService } from 'src/app/_Common/_Services/moneytor-events.service';

@Component({
    selector: 'mt-upload-files',
    templateUrl: 'uploader.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UploaderComponent {
  @Input() bulkActionObj: any;
  @Input() uploadImgObj: any;
  @Input() isTimeline: boolean = false;
  @Output() onSubmitEvent = new EventEmitter<any>();
  showUploadBox: boolean;
  uploadFileObj: any = {};
  isUploading: boolean;
  isLoading: boolean;
  filterParams: any = {};
  fileName: string;

  constructor(
    private uploaderService: UploaderService,
    public snackBar: MatSnackBar,
    private eventService: MoneytorEventsService
  ) {
    this.clearUploads();
  }

  clearUploads() {
    this.uploadFileObj = {};
  }

  cancelUpload() {
    this.clearUploads();
    this.onSubmitEvent.emit({ close: true });
  }
  handleFileInput(event) {
    if (event.target.files.length > 0) {
      this.uploadFileObj.uploadFile = event.target.files[0];
      let fileType = this.uploadFileObj.uploadFile;
      this.fileName = fileType.name
      if (fileType && fileType.name) {
        fileType = fileType.name.toString().toLowerCase();
        fileType = fileType.split('.');
        const type = fileType;
        if (this.isTimeline) {
          if (event.target.files[0].size <= 25 * 1024 * 1024) {
            this.uploadImgObj.file = event.target.files[0];
          } else {
            this.showErr('File size should not exceed 12MB', 'Got it');
          }
        } else {
          if (
            type &&
            type.length > 0 &&
            (type[type.length - 1] === 'xls' || type[type.length - 1] === 'xlsx' || type[type.length - 1] === 'csv')
          ) {
            this.isUploading = false;
          } else {
            this.isUploading = true;
            this.showErr(
              `Sorry, 
            '${this.uploadFileObj.uploadFile.name}' 
            is invalid, allowed extensions are: (.xls, .xlsx, .csv) files`,
              'Got it!'
            );
          }
          // todo: file size conditon will do later
        }
      }
    }
  }
  onUploadFile() {
    this.isLoading = true;
    this.isUploading = true;
    if (this.isTimeline) {
      this.uploaderService.uploadImgProof(this.uploadImgObj).subscribe(res => {
        if (res && res.resultShort === 'success') {
          this.onSubmitEvent.emit({ flag: true });
          this.eventService.paymentUpdated.emit({ dueId: this.uploadImgObj.data.DueId });
        }
        this.showErr(res.resultLong, res.resultShort);
        this.isUploading = false;
        this.isLoading = false;
      });
    } else {
      this.uploaderService.uploadFile(this.uploadFileObj).subscribe(res => {
        if (res && res.result === 'Success') {
          this.filterParams = {
            DuesList: res.data,
            extPag: false,
            fileName: this.fileName
          };
          this.onSubmitEvent.emit({ flag: true, data: this.filterParams, limit: 20, offset: 0 });
        }
        this.showErr(res.resultLong, res.result);
        this.isUploading = false;
        this.isLoading = false;
      });
    }
  }

  showErr(m1: string, m2: string) {
    this.snackBar.open(m1, m2, { duration: 4000, panelClass: [m2.toLowerCase()] });
  }
}
